module.exports = __webpack_public_path__ + "img/left_md_2.ead5ea80.jpg";